import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { AuthModule } from './main/content/auth/auth.module';
import { TranslateModule } from '@ngx-translate/core';
// Apollo
import { GraphQLModule } from './graphql.module';
const appRoutes: Routes = [

    {
        path: 'inspection',
        loadChildren: './main/content/content.module#ContentModule'
    },
    {
        path: '**',
        redirectTo: '/login'
    }
];

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        AuthModule,
        GraphQLModule
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/app.module.ts